export default function cloudinaryLoader({ src, width, quality }) {
    const q = quality || 80;
    return `https://res.cloudinary.com/honeybook/image/upload/f_auto,q_${q},w_${width}/${src}`;
}
